import i18n from '@/utils/i18n';

const filters =
    [
        {
            name: "name",
            id: "name",
            placeholder: i18n.t('groups.search_be_name'),
            value: "",
            type: "text",
            label: i18n.t('form.name'),
            main: false
        },
        {
            name: "type",
            searchable: false,
            id: "company_subdivision",
            placeholder: i18n.t('form.any'),
            value: "",
            type: "select",
            preselectFirst: true,
            multiple: false,
            options: [
                {
                    label: 'Any',
                    value: ''
                },
                {
                    label: 'Company',
                    value: 'company'
                },
                {
                    label: 'Personal',
                    value: 'personal'
                },
                {
                    label: 'Company Subdivision',
                    value: 'company_subdivision'
                },
                {
                    label: 'Organization',
                    value: 'organization'
                },
                {
                    label: 'Educational Institution',
                    value: 'educational_institution'
                },
                {
                    label: 'Multi User',
                    value: 'multi_user'
                }
            ],
            label: i18n.t('groups.group_type'),
            main: false
        }
    ];

export default filters
